export enum UserStatus {
    Active = 1,
    Suspended = 2,
    ExpiredLicense = 3,//obsolete
    SubscriptionLimitExceed = 4,
    Deleted = 8,
    Invited = 9,
    Unknown = 255
}
